import SkeletonAvatar from 'antd/es/skeleton/Avatar';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(SkeletonAvatar);
